var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.551 29.57a1.963 1.963 0 01-1.961-1.961v-6.863a8.837 8.837 0 00-6.222-8.436 2.941 2.941 0 10-5.2.007 8.923 8.923 0 00-6.226 8.514v6.778a1.963 1.963 0 01-1.962 1.961.981.981 0 00-.98.98v3.922a.981.981 0 00.98.98h7.389a3.479 3.479 0 00-.035.49 3.432 3.432 0 106.828-.49h7.389a.981.981 0 00.98-.98v-3.921a.981.981 0 00-.98-.981zM23.766 9.961a.98.98 0 11-.98.98.982.982 0 01.98-.98zm1.471 25.982a1.471 1.471 0 11-2.858-.49h2.775a1.465 1.465 0 01.082.49zm8.334-2.451h-19.61v-2.085a3.929 3.929 0 002.941-3.8v-6.776a6.919 6.919 0 016.839-6.948h.025a6.863 6.863 0 016.863 6.863v6.863a3.929 3.929 0 002.941 3.8z",
    fill: "#6d6e71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.843 21.727a.981.981 0 01-.98-.98 4.908 4.908 0 014.9-4.9.98.98 0 010 1.961 2.945 2.945 0 00-2.941 2.941.981.981 0 01-.979.978z",
    fill: "#97144d"
  })));
}
export default SvgNotificationIcon;